import React, { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { profile } from "../mock";

const links = [
  { label: "Work", href: "#work" },
  { label: "About", href: "#about" },
  { label: "Services", href: "#services" },
  { label: "Contact", href: "#contact" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (href) => {
    setOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-[#FAFAF7]/85 backdrop-blur-md border-b border-[var(--line)]"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="container-wide flex items-center justify-between h-[72px]">
        <a
          href="#top"
          onClick={(e) => {
            e.preventDefault();
            window.scrollTo({ top: 0, behavior: "smooth" });
          }}
          className="flex items-center gap-2.5 group"
        >
          <img
            src="/images/logo-s.svg"
            alt={`${profile.monogram} monogram`}
            className="h-10 w-auto"
          />
          <span className="hidden sm:block text-[13px] tracking-[0.16em] uppercase text-[var(--muted)] group-hover:text-[var(--ink)] transition-colors">
            {profile.name}
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-9">
          {links.map((l) => (
            <button
              key={l.href}
              onClick={() => go(l.href)}
              className="text-[14px] text-[var(--ink)] link-underline"
            >
              {l.label}
            </button>
          ))}
          <button
            onClick={() => go("#contact")}
            className="text-[14px] px-5 py-2.5 bg-[var(--ink)] text-[#FAFAF7] rounded-full hover:bg-[var(--accent)] transition-colors duration-300"
          >
            Let's talk
          </button>
        </nav>

        <button
          className="md:hidden p-2 -mr-2"
          onClick={() => setOpen((o) => !o)}
          aria-label="Menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {/* Mobile menu */}
      <div
        className={`md:hidden overflow-hidden transition-all duration-500 bg-[#FAFAF7] border-b border-[var(--line)] ${
          open ? "max-h-96" : "max-h-0 border-transparent"
        }`}
      >
        <nav className="container-wide py-6 flex flex-col gap-5">
          {links.map((l) => (
            <button
              key={l.href}
              onClick={() => go(l.href)}
              className="text-left font-serif-display text-2xl"
            >
              {l.label}
            </button>
          ))}
        </nav>
      </div>
    </header>
  );
}
